export async function getPasswordKey(encryptKey: string, salt: Uint8Array, keyUsage: KeyUsage, algorithmName: string): Promise<CryptoKey> {
  const textEncoder: TextEncoder = new TextEncoder();
  const key: CryptoKey = await window.crypto.subtle.importKey('raw', textEncoder.encode(encryptKey), 'PBKDF2', false, ['deriveKey']);

  return window.crypto.subtle.deriveKey(
    {
      name: 'PBKDF2',
      salt,
      iterations: 250000,
      hash: 'SHA-256',
    },
    key,
    { name: algorithmName, length: 256 },
    false,
    [keyUsage]
  );
}
